// Word data ships in the app bundle — no Firebase Storage fetch. That
// download URL's token had gone stale (confirmed via a live 403), so every
// real user was silently hitting the bundled fallback anyway. Fetching it
// remotely also meant every user's data was capped at whatever was last
// uploaded there, which was already out of date. The bundled file below is
// the real source of truth now — update it directly when the word lists
// need to change.
import wordDB from '../../wordDatabase.json';

// Category key mapping: singular UI names → plural DB keys
const CATEGORY_MAP = {
  name: 'names',
  animal: 'animals',
  place: 'places',
  thing: 'things',
};

class SoloWordDatabaseService {
  constructor() {
    this.db = wordDB;
    this.initialized = true;
  }

  /** Kept for call-site compatibility — the database is bundled, so this is a no-op. */
  async initialize() {
    return true;
  }

  /**
   * Returns an array of words for the given letter, category, and difficulty tier.
   * @param {string} letter - e.g. 'A'
   * @param {string} category - singular form: 'name' | 'animal' | 'place' | 'thing'
   * @param {string} tier - 'easy' | 'medium' | 'hard'
   */
  getWordsForLetter(letter, category, tier = 'easy') {
    const dbKey = CATEGORY_MAP[category] || category;
    const letterData = this.db[letter.toUpperCase()];
    if (!letterData) return [];
    const categoryData = letterData[dbKey];
    if (!categoryData) return [];

    return categoryData[tier] || categoryData.easy || [];
  }
}

export const soloWordDatabaseService = new SoloWordDatabaseService();
